import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { UitkOverlayButton, UitkButtonSize } from 'uitk-react-button';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { classNames } from 'uitk-react-utils';
import { PlayerStates } from './types.esm.js';
import styles from './uitk-video.css';

var getClassNameList = classNames.bind(styles);
var UitkVideoLayerControls = function (_a) {
    var className = _a.className, controls = _a.controls, playerState = _a.playerState, buttonText = _a.buttonText;
    var l10n = useLocalization();
    var playPauseControls = function () { return (playerState === PlayerStates.get('playing') ? controls.pause : controls.play); };
    var playPauseText = function () {
        if (playerState === PlayerStates.get('playing')) {
            return (buttonText === null || buttonText === void 0 ? void 0 : buttonText.pauseButton) ? buttonText.pauseButton : l10n.formatText('video.pauseButton.label');
        }
        return (buttonText === null || buttonText === void 0 ? void 0 : buttonText.playButton) ? buttonText.playButton : l10n.formatText('video.playButton.label');
    };
    var playerStatesForIsVisuallyHidden = [
        PlayerStates.get('buffering'),
        PlayerStates.get('playing'),
        PlayerStates.get('unstarted')
    ];
    return (React.createElement("div", { className: getClassNameList(className) },
        playerState === PlayerStates.get('paused') ? React.createElement(UitkScrim, { type: UitkScrimType.OVERLAY }) : null,
        React.createElement("button", { type: "button", "aria-label": playPauseText(), className: getClassNameList('uitk-video-layer-controls-link', {
                'is-visually-hidden': playerStatesForIsVisuallyHidden.includes(playerState)
            }), onClick: playPauseControls() },
            React.createElement("span", { className: getClassNameList('is-visually-hidden') }, playPauseText())),
        React.createElement(UitkLayoutPosition, { type: "absolute", position: { top: 'center', left: 'center' }, className: getClassNameList('uitk-video-play-button-wrapper') },
            React.createElement(UitkOverlayButton, { "aria-hidden": "true", tabIndex: -1, onClick: playPauseControls(), size: UitkButtonSize.LARGE, className: getClassNameList({
                    'is-visually-hidden': playerStatesForIsVisuallyHidden.includes(playerState)
                }) },
                React.createElement(UitkIcon, { id: "play", name: "play_arrow", size: UitkIconSize.LARGE, title: playPauseText() })))));
};

export { UitkVideoLayerControls };
